import React from 'react';
import { Container, Row } from 'react-bootstrap';

import { teamApi } from '../../api';

import { hasPermissions } from '../../utils';

import PageTitle from '../../components/common/PageTitle';
import DisabledOverlay from '../../components/common/DisabledOverlay';
import StatementList from '../../components/common/transactions/StatementList';

function Statements({ t, user, setAlert }) {
  return (
    <Container className="main-content-container statements p-3 p-md-5 d-flex flex-column flex-grow-1 d-flex flex-column flex-grow-1">
      <Row className="g-0 page-header mb-3 mb-md-5">
        <PageTitle title={t('settings.statements.title')} backBtn />
      </Row>

      {hasPermissions(user, 'transactions', 'Read') &&
      user &&
      (user.role === 1 || user.role === 2) ? (
        <StatementList
          customer
          setAlert={setAlert}
          user={user}
          filterName={`team_${user.currentTeam.id}_statements`}
          // eslint-disable-next-line no-shadow
          hasPermissions={({ user }) => hasPermissions(user, 'transactions', 'Read')}
          fetchData={teamApi.fetchStatements}
          fetchOptions={{
            team: user.currentTeam.id,
          }}
          generateRowUrl={(data) =>
            `/settings/statement/${data.uuid || data.original.statement_id}/detail`
          }
        />
      ) : (
        <div className="position-relative">
          <DisabledOverlay />
        </div>
      )}
    </Container>
  );
}

export default Statements;
